/* eslint-disable jsdoc/require-returns */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { first } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { ContentState } from '../../../store/state/content.state';
import { AppService } from 'src/app/services/app.service';

@Component({
    selector: 'u4-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ToolbarComponent {
    @Input() loading: boolean;
    @Input() results: number;
    @Input() hint: string;
    @Input() hintText: string;


    public labels: { [key: string]: string };

    constructor(
        private store: Store<ContentState>,
        protected appService: AppService
    ) {
        this.store.select(state => state.labels).pipe(
            first()
        ).subscribe(labels => this.labels = labels);

        this.hintText = this.labels['toolbar.help-text'];
    }

    /**
     * Getter for the total results.
     */
    get resultsLabel() {
        if (this.results === undefined) {
            return;
        }
        return (this.results === 1)
            ? this.labels['general.result']
            : this.labels['general.results'];
    }

    showHint(event: Event, contentPath: string): void {
        event.stopPropagation();
        this.appService.modal.next(contentPath);
    }

}
